if (!customElements.get('auyol-pdp-purchase')) {
  customElements.define('auyol-pdp-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.variants = JSON.parse(this.querySelector('[data-purchase-data]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.onVariant = event => {
        if (this.variants.some(variant => variant.id === event.detail?.variant?.id)) this.render(event.detail.variant.id);
      };
      this.onChange = event => {
        if (event.target.matches('[data-plan-radio]')) {
          this.selectedPlan = event.target.value;
          this.update();
        } else if (event.target.name === 'quantity') this.update();
      };
      document.addEventListener('variant:changed', this.onVariant);
      this.root.addEventListener('change', this.onChange);
      const id = Number(this.root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value);
      this.selectedPlan = new URL(location.href).searchParams.get('selling_plan') || '';
      this.render(id || this.variants[0]?.id);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariant);
      this.root?.removeEventListener('change', this.onChange);
    }
    render(id) {
      this.variant = this.variants.find(item => item.id === id);
      if (!this.variant) return;
      const plans = this.variant.plans;
      if (!plans.some(plan => String(plan.id) === this.selectedPlan)) this.selectedPlan = this.dataset.requiresPlan === 'true' ? String(plans[0]?.id || '') : '';
      const fieldset = this.querySelector('fieldset');
      fieldset.hidden = plans.length === 0;
      const options = this.querySelector('[data-plan-options]');
      options.replaceChildren();
      const add = (plan) => {
        const label = document.createElement('label');
        label.className = 'auyol-pdp-plan';
        const input = document.createElement('input');
        input.type = 'radio'; input.name = `auyol-plan-${this.dataset.section}`;
        input.value = plan ? String(plan.id) : ''; input.dataset.planRadio = '';
        input.checked = input.value === this.selectedPlan;
        const content = document.createElement('span'); content.className = 'auyol-pdp-plan__content';
        const heading = document.createElement('strong');
        const discount = plan ? Math.round((1 - plan.price / this.variant.price) * 100) : 0;
        heading.textContent = plan ? (discount > 0 ? `Save ${discount}% with subscription` : 'Subscribe and save') : 'Buy One Time';
        content.append(heading);
        if (plan) { const note = document.createElement('small'); note.textContent = plan.name; content.append(note); }
        const price = document.createElement('span'); price.className = 'auyol-pdp-plan__price';
        if (plan && plan.price < this.variant.price) {const compare = document.createElement('s');compare.textContent=this.format(this.variant.price);price.append(compare, ' ');}
        const value = document.createElement('strong'); value.textContent = this.format(plan?.price ?? this.variant.price);price.append(value);
        label.append(input, content, price);
        if (plan && discount > 0) {const badge=document.createElement('span');badge.className='auyol-pdp-plan__badge';badge.textContent=`${discount}% SAVINGS`;label.append(badge);}
        options.append(label);
      };
      plans.forEach(add);
      if (this.dataset.requiresPlan !== 'true') add(null);
      this.update();
    }
    format(cents) { return this.money.format(cents / 100); }
    update() {
      if (!this.variant) return;
      const selected = this.variant.plans.find(plan => String(plan.id) === this.selectedPlan);
      const input = this.querySelector('[data-auyol-selling-plan]');
      input.value = selected?.id || ''; input.disabled = !selected;
      const quantity = Math.max(1, Number(this.root.querySelector('form[data-type="add-to-cart-form"] [name="quantity"]')?.value || this.root.querySelector('m-quantity-input input')?.value || 1));
      this.querySelector('[data-purchase-total]').textContent = this.format((selected?.price ?? this.variant.price) * quantity);
      this.querySelector('[data-recurring-row]').hidden = !selected;
      this.querySelector('[data-purchase-recurring]').textContent = selected ? this.format(selected.recurring * quantity) : '';
      this.querySelectorAll('.auyol-pdp-plan').forEach(label => label.classList.toggle('is-selected', label.querySelector('input').checked));
    }
  });
}
if (!customElements.get('auyol-pdp-tabs')) {
  customElements.define('auyol-pdp-tabs', class extends HTMLElement {
    connectedCallback() {
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const select = tab => {
        tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
        this.querySelectorAll('[role="tabpanel"]').forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      };
      this.addEventListener('click', event => {const tab = event.target.closest('[role="tab"]'); if (tab) select(tab);});
      this.addEventListener('keydown', event => {
        const index = tabs.indexOf(event.target);
        if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(tabs[next]); tabs[next].focus();
      });
    }
  });
}

